import * as RadioGroup from '@radix-ui/react-radio-group'
import type { ReactNode } from 'react'

/**
 * Eine Auswahl aus mehreren Karten — Versand oder Abholung, Zahlungsart.
 *
 * # Warum Radix und nicht `<input type="radio">`
 *
 * Ein natives Radio kann fast alles richtig, aber zwei Dinge nicht:
 *
 * Die Pfeiltasten springen über *alle* gleichnamigen Felder im Dokument. Auf
 * der Kasse standen zeitweise zwei Gruppen nebeneinander, und die Namen zu
 * verwechseln kostet nichts weiter als einen stillen Fehler, den man nur mit
 * der Tastatur bemerkt.
 *
 * Und der Fokusring sitzt am kleinen Kreis, nicht an der Karte, die man sieht.
 * Genau darum wurde er hier früher weggestylt — und damit war die Auswahl mit
 * der Tastatur unsichtbar.
 *
 * Radix legt die Rollen und die Tastensteuerung auf die Karte selbst. Wie sie
 * aussieht, bestimmt weiterhin das Stylesheet des Ladens.
 */
export function Wahlgruppe({
  wert,
  onWert,
  label,
  children,
}: {
  wert: string
  onWert: (neu: string) => void
  /** Die Kennung der Überschrift, die diese Gruppe benennt. */
  label: string
  children: ReactNode
}) {
  return (
    <RadioGroup.Root
      className="wahlgruppe"
      value={wert}
      onValueChange={onWert}
      aria-labelledby={label}
      /* Die Schleife ist hier richtig: Eine Auswahl ist ein Kreis, kein Weg
         mit Anfang und Ende, und wer von der letzten Zahlungsart wieder auf
         die erste will, drückt einmal statt dreimal. */
      loop
    >
      {children}
    </RadioGroup.Root>
  )
}

/** Eine Karte darin. */
export function Wahl({
  wert,
  titel,
  text,
  disabled,
}: {
  wert: string
  titel: string
  text?: string
  disabled?: boolean
}) {
  return (
    <RadioGroup.Item className="wahl" value={wert} disabled={disabled}>
      {/* Der Punkt ist nur Anzeige — angeklickt wird die ganze Karte. */}
      <span className="wahl-punkt" aria-hidden="true">
        <RadioGroup.Indicator className="wahl-punkt-kern" />
      </span>
      <span className="wahl-text">
        <strong>{titel}</strong>
        {text && <span className="feld-hinweis">{text}</span>}
      </span>
    </RadioGroup.Item>
  )
}
